
// stnads for the dropdown subjects on subscription process page 2

const subjects = [
  "אדריכלות ועיצוב פנים",
  "אחזקה וניקיון",
  "אלקטרוניקה",
  "אמנות ועיצוב דיגיטלי",
  "אפייה וקונדיטוריה",
  "ביגוד ואופנה",
  "בנייה ושיפוצים",
  "גינון ועיצוב נוף",
  "גרפיקה ועיצוב",
  "הפקת אירועים",
  "הסעדה וקולינריה",
  "השכרת ציוד",
  "כלי בית ועיצוב",
  "כלי עבודה וציוד טכני",
  "מזון ומשקאות",
  "מוזיקה וכלי נגינה",
  "מוצרי טבע ואורגני",
  "מוצרי חיות מחמד",
  "מלונאות ותיירות",
  "ניהול רשתות חברתיות",
  "ספרים ומוצרי קריאה",
  "ספורט וכושר",
  "עבודות יד ו-DIY",
  "פתרונות אחסון",
  "צילום וסטודיו",
  "ציוד משרדי",
  "צעצועים ומוצרי תינוקות",
  "קוסמטיקה וטיפוח",
  "קמפינג וטיולים",
  "רכב ותחבורה",
  "שעונים ותכשיטים",
  "תכשיטים ואביזרים",
  "תעשייה וייצור"
]
;

export default subjects;